module.exports = __webpack_public_path__ + "img/press-4.1c1d871a.jpg";